export default [
  {
    name: 'vethor',
    displayName: 'VeThor',
    decimals: 18,
    ticker: 'VTHO',
    addresses: { current: '0x0000000000000000000000000000456e65726779' },
    info: {
      description:
        'VeThor is a cryptocurrency which is distributed by holding VET in your wallet. VTHO is used to fuel transactions on the VechainThor blockchain.',
      reddit: 'https://www.reddit.com/r/Vechain/',
      twitter: 'https://twitter.com/vechainofficial?lang=en',
      website: 'https://www.vechain.org/',
      telegram: 'https://t.me/vechain_official_english',
    },
    primaryColor: '#2A5E97',
    gradientColors: ['#385AB5', '#2A5E97'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '0%', y2: '100%' },
  },
]
